import type { AccountType } from '../types';

export interface ViewModeOptions {
  accountType?: AccountType;
  isAdmin?: boolean;
  proMode?: 'professional' | 'simple';
  advanced?: boolean;
  hasAdvisorRole?: boolean;
  isAdministration?: boolean;
  /** Den offentlige rundvisning/demo. Den viser hele arbejdspladsen uden login. */
  isDemo?: boolean;
}

/**
 * Determines whether the user should see the professional surface.
 * - Admin always gets professional view (global access).
 * - Professional account gets professional view unless they explicitly switched to 'simple' mode.
 * - Standard accounts always have false for isProView.
 */
export function isProfessionalView(options: ViewModeOptions): boolean {
  if (options.isAdmin) return true;
  if (options.accountType === 'professional') {
    return options.proMode !== 'simple';
  }
  return false;
}

/**
 * Er kontoen en professionel konto?
 *
 * Maalt 16/10: Mikkel gjorde opmaerksom paa at skellet mellem en almindelig og en
 * professionel konto er baerende for hele produktet — en almindelig bruger maa ikke
 * kunne slaa de professionelle flader til selv. Denne svarer paa HVEM kontoen er,
 * uafhaengigt af om en professionel midlertidigt staar i den simple visning.
 */
export function isProfessionalAccount(options: ViewModeOptions): boolean {
  return options.isAdmin === true || options.accountType === 'professional';
}

/**
 * Determines whether advanced surfaces (plans, activities, documents, GPS, export, notes)
 * should be directly shown/highlighted.
 */
export function shouldShowAdvanced(options: ViewModeOptions): boolean {
  if (options.isAdministration) return false;
  if (isProfessionalView(options)) return true;
  // Afkrydsningsfeltet er for en PROFESSIONEL der midlertidigt staar i den simple
  // visning og vil se hele arbejdspladsen igen. Det maa ikke vaere en genvej for en
  // almindelig konto: skellet skal ligge paa kontotypen, ikke paa en indstilling.
  // Den offentlige rundvisning er det eneste andet tilfaelde — den viser hele
  // arbejdspladsen uden login og skal kunne det.
  if ((isProfessionalAccount(options) || options.isDemo) && options.advanced) return true;
  return false;
}
